<template>
    <div class="container">
        <div class="meet-level trans">
            <meet-header
                :headerConfig="headerConfig"
                @handleClickIocn="handleClickIocn"
            />

            <div class="main">
                <h2 class="tit">酒店信息</h2>
                <div class="meet-notice-list" v-for="(item,i) in informList" :key="i">
                    <div @click="handleDetails(item)" class="item shadow"><span  style="width:80%;line-height:1.5"  class="notice-tit">{{item.name}}</span><span class="time">查看详情</span></div>    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import meetHeader from "@/components/header";

export default {
    name: "meetLevel",
    components: {
        meetHeader,
    },
    data() {
        return {
            headerConfig: {
                headerIcon: "city ct-xiangyou",
                headerTitle: "会议概况信息",
            },
            informList:[]
        };

    },
    async created(){
        this.informList = this.$route.params.noticelist
        if (this.$route.params.noticelist) {
            this.informList = this.$route.params.noticelist
        }else {
            let currentConference = await this.$store.dispatch("conference/getCurrentConference")
            this.informList = currentConference.hotels
        } 
    },
    methods: {
        handleClickIocn() {
            history.go(-1);
        },
        handleDetails(item){
            this.$router.push({ name: "hoteldetail", params: { hoteldetail: item }, query: {hotel_id: item.id}})   
        }
    },
};
</script>

<style lang="scss" scoped>
.main {
    width: 100%;
    padding: 0 15px;
    margin-bottom: 30px;
    box-sizing: border-box;

    .tit {
        padding-left: 8px;
        margin-top: 30px;
        border-left: 4px solid var(--main-color);
        font-size: 18px;
        font-weight: bold;
        color: var(--main-color);
    }

   
    .meet-notice-list {
        width: 100%;
        margin-top: 30px;

        .item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px;
            height: 30px;
            border-radius: 5px;
            margin-bottom: 15px;

            &:last-child {
                margin-bottom: 0;
            }

            .notice-tit {
                font-size: 14px;
            }

            .time {
                font-size: 12px;
            }
        }
    }
}
</style>